import { EvaluatorSpec } from "@/types/app/evaluator";
import { TextInput } from "@components/molecules/FormikInput";
import { NumberValenceSelect } from "./HumanEvaluatorFrames/NumberValenceSelect";
import { classNames } from "@/lib/utils";

interface Props<T extends EvaluatorSpec> {
  className?: string;
  draftSpec: T;
  setDraftSpec: (spec: T) => void;
}

export const NumberJudgmentEditor = <T extends EvaluatorSpec>({ className, draftSpec, setDraftSpec }: Props<T>) => {
  return (
    <div className={classNames("flex flex-col gap-32", className)}>
      <div className="flex gap-16">
        <TextInput
          type="number"
          name="Min"
          label="Min"
          className="w-100"
          value={draftSpec.number_limits?.min ?? ""}
          onChange={(event) => {
            const min = event.target.value === "" ? null : parseFloat(event.target.value);
            setDraftSpec({
              ...draftSpec,
              number_limits: { ...(draftSpec.number_limits ?? { min: null, max: null, step: null }), min },
            });
          }}
        />
        <TextInput
          type="number"
          name="Max"
          label="Max"
          className="w-100"
          value={draftSpec.number_limits?.max ?? ""}
          onChange={(event) => {
            const max = event.target.value === "" ? null : parseFloat(event.target.value);
            setDraftSpec({
              ...draftSpec,
              number_limits: { ...(draftSpec.number_limits ?? { min: null, max: null, step: null }), max },
            });
          }}
        />
        <TextInput
          type="number"
          name="Step"
          label="Step"
          className="w-100"
          value={draftSpec.number_limits?.step ?? ""}
          onChange={(event) => {
            const step = event.target.value === "" ? null : parseFloat(event.target.value);
            setDraftSpec({
              ...draftSpec,
              number_limits: { ...(draftSpec.number_limits ?? { min: null, max: null, step: null }), step },
            });
          }}
        />
      </div>
      <div>
        <div className="grow">
          <NumberValenceSelect
            valence={draftSpec.number_valence ?? "neutral"}
            setValence={(valence) => {
              setDraftSpec({ ...draftSpec, number_valence: valence });
            }}
          />
        </div>
      </div>
    </div>
  );
};
